// Make it global by attaching to window
window.initSwipers = function () {
  const swiper_Sections = document.querySelectorAll('[data-swiper_id^="swiper__controls_swiper_related"]');

  if (!swiper_Sections.length) return;

  swiper_Sections.forEach(swiper_Section => {
      const slide_count = parseFloat(swiper_Section.dataset.slide_count) || 4;
      const slide_count_tab = parseFloat(swiper_Section.dataset.slide_count_tab) || 4;
      const slide_count_mobile = parseFloat(swiper_Section.dataset.slide_count_mobile) || 4;
      
      const swiper = new Swiper(`[data-swiper_id="swiper__controls_swiper_related"] .swiper__Container`, {
        freeMode: true,
        observer: true,
        observeParents: true,
        grabCursor: true,
        loop: false,
        preventClicks: true,
        preventClicksPropagation: true,
        pagination: {
          el: `[data-swiper_id="swiper__controls_swiper_related"] .swiper-pagination`,
          clickable: true,
        },
        keyboard: { enabled: true },
        navigation: {
          nextEl: `[data-swiper_id="swiper__controls_swiper_related"] .swiper-button-next`,
          prevEl: `[data-swiper_id="swiper__controls_swiper_related"] .swiper-button-prev`,
        },
        initialSlide: 0,
        slidesPerView: slide_count,
        slidesPerGroup: slide_count,
        spaceBetween: 10,
        breakpoints: {
          680: {
            slidesPerView: slide_count_tab,
            slidesPerGroup: slide_count_tab,
            spaceBetween: 10,
          },
          1200: {
            slidesPerView: slide_count_mobile,
            slidesPerGroup: slide_count_mobile,
            spaceBetween: 10,
          },
        },
      });
    });
};

// Auto-run once on initial page load
document.addEventListener("DOMContentLoaded", () => {
  window.initSwipers();
});
